import useAuth from '@/hooks/useAuth';

export const useMultipleReportsTabsEnabled = () => {
  const { data } = useAuth();

  const isAtLeastLeader =
    (data?.allLocationsWithAtLeastLeaderRoles.length ?? 0) > 0;
  const features = data?.features;
  const hasMultipleReportingTabs =
    !!features?.reporting?.plans?.enabled &&
    (!!features.reporting.teamMember?.enabled ||
      !!features.reporting.compliance?.enabled);

  return isAtLeastLeader && hasMultipleReportingTabs;
};
